import { render, staticRenderFns } from "./myDetailGift.vue?vue&type=template&id=10585c2e&scoped=true"
import script from "./myDetailGift.vue?vue&type=script&lang=js"
export * from "./myDetailGift.vue?vue&type=script&lang=js"
import style0 from "./myDetailGift.vue?vue&type=style&index=0&id=10585c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10585c2e",
  null
  
)

export default component.exports